import React from "react";


const UnauthorizedMessage = () => {
    return (
        <div className="card-box" style={{margin: '20px', padding: '20px', textAlign: 'center'}}>
            <h2>Access Denied</h2>
            <p>
                Please log in via the main Login page to view social features and club information.
                <br/>
                You can find the Login option in "my profile".
            </p>
        </div>
    )
}

export default UnauthorizedMessage;